var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTicketWhite46X46 = function SvgTicketWhite46X46(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.933.75A1.183 1.183 0 0 0 .75 1.933v16.561a1.183 1.183 0 0 0 1.922.924l5.175-4.139 5.175 4.14a1.183 1.183 0 0 0 1.922-.924V1.934A1.183 1.183 0 0 0 13.762.75Z",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  })));
};
export default SvgTicketWhite46X46;